module.exports = __webpack_public_path__ + "static/media/objects2_03.524109f5.svg";